import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@grebban/style-system-react';
import Text from 'components/Text';

const Wrapper = styled('div')``;

const ContactLink = styled('a')`
    text-decoration: underline;
    color: inherit;
`;

const TYPOGRAPHY = ['Primary/Mobile/13_100_510_-1', null, null, null, null, 'Primary/15_120_510_-1'];

const NoResults = () => {
    const { t } = useTranslation();

    return (
        <Wrapper>
            <Text typography={TYPOGRAPHY}>
                {t('category.filter.no_results_prefix')}
                <ContactLink href={t('category.filter.no_results_contact_url')}>
                    {t('category.filter.no_results_contact_label')}
                </ContactLink>
                .
            </Text>
        </Wrapper>
    );
};

export default NoResults;
